/* Custom-styled cookie consent banner.
   Stores the visitor's choice locally (source of truth for showing the
   banner) and, best-effort, forwards it to Shopify's Customer Privacy API
   so checkout/Shopify Pixels respect it too, plus Google Consent Mode for
   the gtag snippet already loaded in theme.liquid. */
(function () {
  var STORAGE_KEY = 'ir_cookie_consent';
  var root = document.getElementById('ir-cookie-banner');
  var modal = document.getElementById('ir-cookie-modal');
  if (!root || !modal) return;

  var analyticsToggle = modal.querySelector('[data-cookie-pref="analytics"]');
  var marketingToggle = modal.querySelector('[data-cookie-pref="marketing"]');
  var privacyApi = null;

  function readStoredConsent() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function storeConsent(consent) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
    } catch (e) {}
  }

  function updateGoogleConsent(consent) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('consent', 'update', {
      ad_storage: consent.marketing ? 'granted' : 'denied',
      ad_user_data: consent.marketing ? 'granted' : 'denied',
      ad_personalization: consent.marketing ? 'granted' : 'denied',
      analytics_storage: consent.analytics ? 'granted' : 'denied',
    });
  }

  function syncShopifyConsent(consent) {
    if (!privacyApi || typeof privacyApi.setTrackingConsent !== 'function') return;
    try {
      privacyApi.setTrackingConsent(
        {
          analytics: consent.analytics,
          marketing: consent.marketing,
          preferences: true,
          sale_of_data: consent.marketing,
        },
        function () {}
      );
    } catch (e) {}
  }

  function showBanner() {
    root.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add('is-visible');
    });
  }

  function hideBanner() {
    root.classList.remove('is-visible');
    window.setTimeout(function () {
      root.hidden = true;
    }, 300);
  }

  function openModal() {
    var stored = readStoredConsent();
    if (analyticsToggle) analyticsToggle.checked = !!(stored && stored.analytics);
    if (marketingToggle) marketingToggle.checked = !!(stored && stored.marketing);
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ir-cookie-modal-open');
    requestAnimationFrame(function () {
      modal.classList.add('is-visible');
    });
  }

  function closeModal() {
    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ir-cookie-modal-open');
    window.setTimeout(function () {
      modal.hidden = true;
    }, 300);
  }

  function applyConsent(consent) {
    consent.preferences = true;
    storeConsent(consent);
    updateGoogleConsent(consent);
    syncShopifyConsent(consent);
    hideBanner();
    closeModal();
  }

  root.addEventListener('click', function (event) {
    var el = event.target;
    if (el.closest('[data-cookie-accept]')) {
      applyConsent({ analytics: true, marketing: true });
    } else if (el.closest('[data-cookie-reject]')) {
      applyConsent({ analytics: false, marketing: false });
    } else if (el.closest('[data-cookie-manage]')) {
      openModal();
    }
  });

  modal.addEventListener('click', function (event) {
    var el = event.target;
    if (el.closest('[data-cookie-modal-close]')) {
      closeModal();
    } else if (el.closest('[data-cookie-accept]')) {
      applyConsent({ analytics: true, marketing: true });
    } else if (el.closest('[data-cookie-reject]')) {
      applyConsent({ analytics: false, marketing: false });
    } else if (el.closest('[data-cookie-save]')) {
      applyConsent({
        analytics: !!(analyticsToggle && analyticsToggle.checked),
        marketing: !!(marketingToggle && marketingToggle.checked),
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });

  var stored = readStoredConsent();
  if (!stored) {
    showBanner();
  } else {
    updateGoogleConsent(stored);
  }

  (function loadPrivacyApi(attempts) {
    attempts = attempts || 0;
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error || !window.Shopify.customerPrivacy) return;
        privacyApi = window.Shopify.customerPrivacy;
        if (stored) syncShopifyConsent(stored);
      });
      return;
    }
    if (attempts > 40) return;
    window.setTimeout(function () {
      loadPrivacyApi(attempts + 1);
    }, 250);
  })();
})();
